import { SvgIconProps } from '@mui/material';
import React from 'react';

export default function IcEditGeoZone(props: SvgIconProps) {
    return (
        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M9.26199 14.0981H14.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.56334 2.07451C9.12352 1.405 10.1305 1.30683 10.8139 1.85563C10.8517 1.8854 12.0657 2.8285 12.0657 2.8285C12.8165 3.28235 13.0498 4.24717 12.5857 4.98347C12.561 5.0229 5.69752 13.6082 5.69752 13.6082C5.46917 13.893 5.12254 14.0612 4.7521 14.0652L2.12366 14.0982L1.53144 11.5916C1.44848 11.2391 1.53144 10.869 1.75978 10.5841L8.56334 2.07451Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.29282 3.66797L11.2305 6.692"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
